<template>
  <div
    class="dropdown br-dropdown"
    v-bind:data-ri-filtername="filterName"
    data-ri-filtervalue="this .selectedTitle"
    data-ri-force="true"
  >
    <label class="form-label"> </label>
    <p
      class="dropdown__selected selected selectedTitle find-rate__selected-content +mg-bottom-none +pd-bottom-none +pd-top-none"
      v-bind:class="{ '--is-active': isExpanded, '--disabled': disabled }"
      v-on:click.stop="toggleAction()"
    >
      <span v-if="selectedLenderHasLogo">
        <img
          v-bind:src="
            'https://www.brimg.net/system/img/inst/' + selectedLender.logo
          "
          alt="logo"
        />
        <span class="+display-none">{{ selectedLender.advertiser }}</span>
      </span>
      <span v-else>{{ selectedLender.advertiser }}</span>
      <svg
        class="dropdown__arrow"
        width="13px"
        height="13px"
        viewBox="0 0 13 13"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g
          id="Page-1"
          stroke="none"
          stroke-width="1"
          fill=""
          fill-rule="evenodd"
        >
          <g id="Icons" transform="translate(-340.000000, -38.000000)" fill="">
            <g
              id="dropdown-arrow-inactive"
              transform="translate(340.000000, 38.000000)"
            >
              <path
                d="M6.86396103,10.9497475 L6.86396103,0 L5.86396103,0 L5.86396103,10.9497475 L0.707106781,5.79289322 L0,6.5 L6.36396103,12.863961 L6.71751442,12.5104076 L12.7279221,6.5 L12.0208153,5.79289322 L6.86396103,10.9497475 Z"
                id="Combined-Shape"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </p>
    <div
      class="find-rate__dropdown-wrapper br-dropdown-container"
      v-show="isExpanded"
    >
      <div class="find-rate__arrow"></div>
      <div class="dropdown__list-container">
        <ul class="list-bare dropdown__list-wrapper +mg-none">
          <li>
            <p class="find-rate__dropdown-header +mg-bottom-none +pd-left-xs">
              Choose an available rate from a lender below
            </p>
            <p class="find-rate__dropdown-product-header +pd-left-xs" v-cloak>
              {{ productHeadline }}
            </p>
          </li>
          <li
            class="grid find-rate__dropdown-item"
            :class="isSelectedItem(item) ? 'selected' : ''"
            v-for="(item, index) in options"
            :key="index"
            @click.stop="changeAction(item)"
          >
            <div class="grid-cell size-1of2 +pd-top-xs +text-center">
              <img
                v-if="item.logo !== ''"
                v-bind:src="
                  'https://www.brimg.net/system/img/inst/' + item.logo
                "
                alt="logo"
                class="+border +mg-bottom-xs"
              />
              <p v-else>{{ item.advertiser }}</p>
            </div>
            <div
              class="grid-cell size-1of2 find-rate__lender-rate +text-center"
            >
              <p class="numeral --gamma +mg-bottom-none">
                {{ item.apr
                }}<span class="numeral__accent --percentage">% APR</span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
@import '../../../../../sass/brcom/settings/_settings.global.scss';
@import '../../../../../sass/brcom/settings/_settings.theme-colors.scss';
@import '../../../../../sass/brcom/tools/_tools.rem.scss';
.find-rate__dropdown-wrapper {
  @include rem(left, -120px);
  @include rem(margin-top, 15px);
  background: $theme-white;
  position: absolute;
  width: 150%;
}
.find-rate__dropdown-item {
  &:hover {
    background: $theme-blue;
    color: $theme-white;
  }
}
.find-rate__lender-rate {
  align-items: center;
  display: flex;
  justify-content: center;
}
.find-rate__dropdown-header {
  @include rem(font-size, 16px);
  @include rem(margin-top, 8px);
  color: $theme-charcoal;
  font-family: $global-body-font-calibre;
}
.find-rate__dropdown-product-header {
  @include rem(font-size, 18px);
  @include rem(margin-bottom, 3px);
  font-family: $global-body-font-calibre;
  line-height: 1.2;
  text-transform: uppercase;
}
.find-rate__selected-content {
  align-items: center;
  display: flex;
}
.find-rate__arrow {
  @include rem(top, (0 - $global-spacing-unit-xxs));
  @include rem(right, 40px);
  border-left: rem($global-spacing-unit-xxs) solid transparent;
  border-right: rem($global-spacing-unit-xxs) solid transparent;
  height: 0;
  position: absolute;
  width: 0;

  &::after {
    @include rem(top, 1px);
    border-bottom: rem($global-spacing-unit-xxs - 1px) solid $theme-white;
    border-left: rem($global-spacing-unit-xxs - 1px) solid transparent;
    border-right: rem($global-spacing-unit-xxs - 1px) solid transparent;
    content: '';
    height: 0;
    position: absolute;
    width: 0;
  }
}
</style>
<script>
import utils from './../../../../bankrate-utilities/index'
import eventHub from '../../../bankrate-events'
export default {
  props: {
    // General settings for the component
    settings: {
      default: function() {
        return {
          uniqueId: '',
          title: ''
        }
      }
    },

    // Options
    options: {
      default: function() {
        return []
      }
    },

    default: {
      default: function() {
        return ''
      }
    },

    productHeadline: {
      default: function() {
        return ''
      }
    },

    // Filter title for DataCollector
    filterTitle: {
      default: ''
    },

    // The tooltip data
    copy: {
      default: function() {
        return []
      }
    },

    disabled: {
      default: function() {
        return false
      }
    }
  },

  data: function() {
    return {
      // The status of the drop-down
      isExpanded: false,
      selected: ''
    }
  },

  computed: {
    /**
     * Verify if are a single element selected
     *
     * @returns {String}
     */

    selectedLender: function() {
      return this.selected
    },

    /**
     * @return boolean
     */
    selectedLenderHasLogo: function() {
      return this.selected.hasOwnProperty('logo') && this.selected.logo !== ''
    },

    filterName: function() {
      return utils.dataCollectorFormat(
        this.filterTitle ? this.filterTitle : this.settings.title.toLowerCase()
      )
    }
  },

  created: function() {
    this.selected = this.default
    // Listening events
    eventHub.$on('dropDown::close', this.closeEvent)
    eventHub.$on('findARate::reset', this.reset)
    eventHub.$on('findARate::refreshLenderRate', this.refreshLenderRate)
  },

  methods: {
    /**
     * Check to make sure selecttion isn't default, then update lender info
     */
    refreshLenderRate: function() {
      if (this.selectedLender.hasOwnProperty('apr')) {
        let lender = this.selectedLender.advertiser
        this.changeAction(
          this.options.filter(function(obj) {
            return obj.advertiser === lender
          })[0]
        )
      }
    },

    /**
     * Verifies if the current element is selected
     * @param item
     */
    isSelectedItem: function(item) {
      // TODO: implement this using lodash or a handmade solution
      if (typeof this.selected === 'string') {
        return this.selected === item.value
      } else {
        return JSON.stringify(this.selected) === JSON.stringify(item.value)
      }
    },

    /**
     * Process the close event
     */
    closeEvent: function() {
      if (this.isExpanded) {
        this.isExpanded = false
      }
    },

    /**
     * Process the reset event
     */
    resetEvent: function(event) {
      if (event.uniqueId === this.settings.uniqueId) {
        this.reset()
      }
    },

    /**
     * Toggle drop-down show/hide state
     */
    toggleAction: function() {
      if (this.disabled) {
        return
      }

      if (this.isExpanded === true) {
        this.isExpanded = false
      } else {
        eventHub.$emit('dropDown::close')
        this.isExpanded = true
      }
    },

    /**
     * Main action (drop-down change for options click)
     * The event emitted by this component is always dropDownChange
     * The data sent with the event is an object like:
     * {name: the_unique_identifier_of_this_component, item: the_value_for_this_item}
     *
     * @param item
     * @returns {void}
     */
    changeAction: function(item) {
      if (
        `${this.selected.productuid} ${this.selected.svyinstitutionid}` !==
        `${item.productuid} ${item.svyinstitutionid}`
      ) {
        this.selected = item
        this.notifyChanges()
      }
      if (this.isExpanded) {
        this.toggleAction()
      }
    },

    /**
     * Reset the component selection
     */
    reset: function() {
      this.selected = this.default
      eventHub.$emit('findARate::change', this.selected)
    },

    notifyChanges: function() {
      eventHub.$emit('findARate::change', this.selected)
    }
  }
}
</script>
